import useKlydoQuery from './useKlydoQuery';
import studioApiClient from '../api/studio';

type UseContractContentOptions = {
  enabled?: boolean;
};

const useContractContent = (options?: UseContractContentOptions) => {
  return useKlydoQuery<{ html: string }>({
    queryKey: ['contractContent'],
    queryFn: () => studioApiClient.getContractContent(),
    enabled: options?.enabled,
  });
};

export default useContractContent;
